module.exports = __webpack_public_path__ + "img/1-2_hybrid-master-car-1.73ae39b3.gif";